import BaseCollection from "lib/collection";
import Catalog from "models/catalog";

export default BaseCollection.extend({
    mainIndex: "id",
    url: "/api/v3.1/catalogs",
    model: Catalog,
});
